import { useSelector } from 'react-redux'
import * as React from 'react'
import { ApplicationState } from './../store/index'
import { SectionTitle } from 'traveldesk-ui'
export const LoadingSection = () => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    return <SectionTitle title={`${Localization.getString('Loading')}...`} />
}
